import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Link} from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
//import pending from "../../assets/img/pending.png";
//import approve from "../../assets/img/approve.png";
//import reject from "../../assets/img/reject.png";
//import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
//import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class BrandMappedData extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[]
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        this._refreshUnmapped();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        //var _notificationSystem = this.refs.notificationSystem;
    }

    unmappedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            unmappedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            unmappedModel: !this.state.unmappedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }


    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }
    
    _refreshUnmapped() {
        if ($.fn.DataTable.isDataTable('#brandmappedTable')) {
            $('#brandmappedTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL')+'/brandemi/get_brand_mapped',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
            }).then(response => {
            console.log(response);
            this.setState({
                unmapped_files: response.data
            });
            $('#brandmappedTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }

    render() {

        let unmapped_data = this.state.unmapped_files.map((unmapped,index) => {
            return (
                    <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{unmapped.user_id}</td>
                    <td>{unmapped.file_name}</td>
                    <td>{unmapped.user_type}</td>
                    <td>{unmapped.record_update_timestamp}</td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="View"  to={"/admin/mapped-view/" + unmapped.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>         
                    </td>
                </tr>
            )
        });

        
        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                        
                    <div className="content table-full-width table-responsive">
                        <table className="table table-striped table-hover" id="brandmappedTable">
                            <thead>
                            <tr>
                                <th>Sr_No.</th>
                                <th>User_ID</th>
                                <th>File_Name</th>
                                <th>User_Type</th>
                                <th>Timestamp</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {unmapped_data}
                            </tbody>
                        </table>
                    </div>

                    <div className="footer">
                        <div className="stats"><i></i></div>
                    </div>
                </div>

            </div>
        );
    }
}
export default BrandMappedData;